import { useApi } from '@omnipresentgroup/api';
import { sortObjectsByKey } from '@omnipresentgroup/helpers';
import type {
  GetCountriesResponse,
  GetCountriesResponseAPI,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, COUNTRIES_API_PATH } from '../constants';

export enum CountriesPurpose {
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  RESIDENCE = 'RESIDENCE',
}

export const useSupportedCountries = ({
  purpose,
}: {
  purpose: CountriesPurpose;
}) => {
  const { GET } = useApi();

  return useQuery<GetCountriesResponseAPI, unknown, GetCountriesResponse>({
    queryKey: [COUNTRIES_API_PATH, purpose],
    queryFn: () =>
      GET<GetCountriesResponseAPI>(
        `${API_BASE}/${COUNTRIES_API_PATH}?purpose=${purpose}`,
      ),
    select: (data) => sortObjectsByKey({ key: 'name', list: data }),
  });
};
